import React from 'react';

const TextInput = props => <input className="text-input" {...props} />;

export default TextInput;
